/**
 * @desc iam单点登出
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(params: API.ucenter.iamCallback.logout.Params, options?: any) {
  return updateResponse(
    http(URL + `/iam/callback/logout`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
